import { Controller } from "@hotwired/stimulus"
import { api } from "../services/api";

export default class extends Controller {
  static outlets = [ "app" ]
  static values = {
    renderPath: String
  }

  declare readonly appOutlet: any;
  declare readonly renderPathValue: string
  static targets = [ "attachment" ]
  declare readonly attachmentTargets: HTMLElement[];

  get form(): HTMLFormElement { return this.element as HTMLFormElement }

  connect() {
  }

  attachmentTargetConnected(e: Event) {
    console.log('attachmentTargetConnected', e);
  }

  render = async () => {
    await api.putTurbo(this.renderPathValue, new FormData(this.form));
  }
}
